(() => {
  if (window.__entinaProductTrustBound) return;
  window.__entinaProductTrustBound = true;
  let activeModal = null;
  const focusable = (root) => [...root.querySelectorAll('button:not([disabled]),a[href],summary,[tabindex]:not([tabindex="-1"])')].filter((el) => !el.hasAttribute('hidden') && el.offsetParent !== null);
  const close = (modal, restore = true) => {
    if (!modal) return;
    modal.classList.remove('is-open');
    document.documentElement.classList.remove('entina-trust-modal-open');
    const trigger = modal.__entinaTrustTrigger;
    if (activeModal === modal) activeModal = null;
    setTimeout(() => {
      modal.hidden = true;
      if (restore && trigger && trigger.focus) trigger.focus({preventScroll:true});
    }, 180);
  };
  const open = (trigger) => {
    const modal = document.getElementById(trigger.dataset.entinaTrustOpen || '');
    if (!modal) return;
    if (activeModal && activeModal !== modal) close(activeModal, false);
    const target = trigger.dataset.entinaTrustTarget;
    modal.querySelectorAll('[data-entina-trust-panel]').forEach((panel) => panel.open = panel.dataset.entinaTrustPanel === target);
    modal.__entinaTrustTrigger = trigger;
    modal.hidden = false;
    activeModal = modal;
    document.documentElement.classList.add('entina-trust-modal-open');
    requestAnimationFrame(() => {
      modal.classList.add('is-open');
      modal.querySelector('.entina-trust-modal__close')?.focus({preventScroll:true});
    });
  };
  document.addEventListener('click', (event) => {
    const trigger = event.target.closest('[data-entina-trust-open]');
    if (trigger) { event.preventDefault(); open(trigger); return; }
    const closer = event.target.closest('[data-entina-trust-close]');
    if (closer) { event.preventDefault(); close(closer.closest('[data-entina-trust-modal]')); }
  });
  document.addEventListener('keydown', (event) => {
    if (!activeModal || activeModal.hidden) return;
    if (event.key === 'Escape') { event.preventDefault(); close(activeModal); return; }
    if (event.key !== 'Tab') return;
    const items = focusable(activeModal);
    if (!items.length) return;
    const first = items[0], last = items[items.length - 1];
    if (event.shiftKey && document.activeElement === first) { event.preventDefault(); last.focus(); }
    else if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first.focus(); }
  });
  document.addEventListener('toggle', (event) => {
    const opened = event.target;
    if (!(opened instanceof HTMLDetailsElement) || !opened.matches('[data-entina-trust-panel]') || !opened.open) return;
    opened.closest('.entina-trust-modal__accordion')?.querySelectorAll('[data-entina-trust-panel]').forEach((panel) => {
      if (panel !== opened) panel.open = false;
    });
  }, true);
})();